import { z } from "zod";

const httpUrl = z.string().regex(/^https?:\/\//i);

export const CartItemSchema = z.object({
  productTitle: z.string().min(1),
  variantTitle: z.string().nullable().optional(),
  imageUrl: httpUrl.nullable().optional(),
  quantity: z.number().int().min(1),
  price: z.number(),
});

export const CartCardSchema = z.object({
  cartId: z.string().min(1),
  store: z.string().min(1),
  brand: z.string().min(1),
  items: z.array(CartItemSchema).min(1),
  totalAmount: z.number(),
  currency: z.string().default("USD"),
  checkoutUrl: httpUrl,
  // Bare domain of the store the checkout actually lands on (e.g.
  // "pickleballcentral.com") — drives the CTA label so it matches the real
  // checkout, not the product brand. Falls back to `${brand}.com` when absent.
  storeDomain: z.string().optional(),
  // Overrides the button label when the link isn't a plain checkout — e.g. a
  // racquet routes to its product page to pick a grip ("Pick your grip on ...").
  ctaLabel: z.string().optional(),
});

export type CartItemData = z.infer<typeof CartItemSchema>;
export type CartCardData = z.infer<typeof CartCardSchema>;

export function validateCartCard(value: unknown): CartCardData | null {
  const parsed = CartCardSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
